import { MAIN_FILTERS, MAIN_FILTERS_WITH_AMENITIES } from "../../data/filtersList";

const reorderFilter = (region: any, includeAmenities = false) => {
  const baseFilters = includeAmenities ? MAIN_FILTERS_WITH_AMENITIES : MAIN_FILTERS;
  const ORDERED_FILTERS = JSON.parse(JSON.stringify(baseFilters));

  if (
    region?.location?.country?.long_name == "Australia" ||
    region?.location?.country?.long_name == "United States"
  ) {
    const element = ORDERED_FILTERS.splice(2, 1)[0];

    // Insert the element at the fifth position (index 4)
    ORDERED_FILTERS.splice(4, 0, element);
  }

  return ORDERED_FILTERS;
};
export const getLocalityOrUniversityTitle = (
  countryShortName: string,
  sourceCountry: string,
  filtersState: any,
) => {
  if (countryShortName !== sourceCountry) {
    return !filtersState?.university ? "University" : "";
  }
  return !filtersState?.locality ? "Locality" : "";
};

export const hasAnyAmenitiesOptions = (filterCountData: any): boolean =>
  !!filterCountData?.amenities_grouped?.some((cat: any) =>
    cat?.values?.some((amenity: any) => Number(amenity?.count) > 0),
  );

export const hasAnyBillsIncludedOptions = (filterCountData: any): boolean =>
  !!filterCountData?.bills_included &&
  Object.values(filterCountData.bills_included).some((count: unknown) => Number(count) > 0);

/**
 * Hide Amenities / Bills Included when:
 * - inventory results are 0, or
 * - filter-count data has loaded and that filter has no options with count > 0
 * Never use a stale inventory_filter_count meta.count as a 0-results signal.
 */
export const shouldHideAmenitiesOrBillsPill = ({
  isActive,
  isFilterCountLoading,
  inventoryCount,
  hasAnyOptions,
  hasFilterCountPayload,
}: {
  isActive: boolean;
  isFilterCountLoading?: boolean;
  inventoryCount?: number | null;
  hasAnyOptions: boolean;
  hasFilterCountPayload: boolean;
}): boolean => {
  if (isActive) return false;
  const isInventoryCountZero =
    inventoryCount !== undefined && inventoryCount !== null && Number(inventoryCount) === 0;
  if (isInventoryCountZero) return true;
  if (isFilterCountLoading || !hasFilterCountPayload) return false;
  return !hasAnyOptions;
};

export const getBadgeValue = (
  isWhitelabel: boolean,
  isUniversityPartner: boolean,
  whitelabelTitle: string,
  title: string,
) => {
  if (!isWhitelabel) return title;
  return isUniversityPartner && whitelabelTitle === "University" ? "Campuses" : whitelabelTitle;
};

export default reorderFilter;
